export function inferMimeType(fileName, type) {
  const normalizedName = (fileName || '').toLowerCase();

  if (normalizedName.endsWith('.pdf')) return 'application/pdf';
  if (normalizedName.endsWith('.png')) return 'image/png';
  if (normalizedName.endsWith('.jpg') || normalizedName.endsWith('.jpeg')) return 'image/jpeg';
  if (normalizedName.endsWith('.webp')) return 'image/webp';
  if (normalizedName.endsWith('.gif')) return 'image/gif';
  if (normalizedName.endsWith('.svg')) return 'image/svg+xml';
  if (normalizedName.endsWith('.txt')) return 'text/plain';
  if (normalizedName.endsWith('.csv')) return 'text/csv';
  if (normalizedName.endsWith('.json')) return 'application/json';
  if (normalizedName.endsWith('.xml')) return 'application/xml';
  if (normalizedName.endsWith('.log')) return 'application/log';
  if (normalizedName.endsWith('.xlsx')) {
    return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  }
  if (normalizedName.endsWith('.xls')) return 'application/vnd.ms-excel';
  if (normalizedName.endsWith('.docx')) {
    return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
  }
  if (normalizedName.endsWith('.doc')) return 'application/msword';
  if (normalizedName.endsWith('.pptx')) {
    return 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
  }
  if (normalizedName.endsWith('.ppt')) return 'application/vnd.ms-powerpoint';

  if (type === 'fattura') return 'application/pdf';
  return 'application/octet-stream';
}

function buildMockDownloadUrl({ fileName, mimeType }) {
  const content = [
    `Documento mock: ${fileName}`,
    `Mime type: ${mimeType}`,
    'Questo riferimento file esiste per supportare download realistici nel modulo documents.',
  ].join('\n');

  return `data:${mimeType};charset=utf-8,${encodeURIComponent(content)}`;
}

export function buildDocumentFileMeta({ fileName, mimeType }) {
  const resolvedFileName = fileName || 'documento.dat';
  const normalizedMimeType = typeof mimeType === 'string' ? mimeType.trim().toLowerCase() : '';
  const resolvedMimeType =
    !normalizedMimeType ||
    normalizedMimeType === 'application/octet-stream' ||
    normalizedMimeType === 'binary/octet-stream' ||
    normalizedMimeType === 'application/unknown'
      ? inferMimeType(resolvedFileName)
      : mimeType;
  const downloadUrl = buildMockDownloadUrl({
    fileName: resolvedFileName,
    mimeType: resolvedMimeType,
  });

  return {
    fileName: resolvedFileName,
    mimeType: resolvedMimeType,
    downloadUrl,
    previewUrl: downloadUrl,
  };
}

export function hydrateDocumentRecord(document) {
  const fileMeta = buildDocumentFileMeta({
    fileName: document.fileName || document.name,
    mimeType: document.mimeType || inferMimeType(document.fileName || document.name, document.type),
  });
  const resolvedDownloadUrl =
    typeof document.downloadUrl === 'string' ? document.downloadUrl : fileMeta.downloadUrl;
  const resolvedPreviewUrl =
    typeof document.previewUrl === 'string'
      ? document.previewUrl
      : fileMeta.previewUrl;

  return {
    ...document,
    ...fileMeta,
    downloadUrl: resolvedDownloadUrl,
    previewUrl: resolvedPreviewUrl,
  };
}

export function buildUploadedDocument({ documents, form, uploadedFile }) {
  return {
    id: documents.length + 1,
    name: uploadedFile.name,
    type: uploadedFile.type.includes('pdf') ? 'pdf' : 'documento',
    size: `${(uploadedFile.size / 1024 / 1024).toFixed(2)} MB`,
    uploadDate: form.uploadDate,
    uploadedBy: form.uploadedBy,
    client: form.client,
    category: form.category,
    status: 'in_revisione',
    ...buildDocumentFileMeta({
      fileName: uploadedFile.name,
      mimeType: uploadedFile.type || inferMimeType(uploadedFile.name),
    }),
  };
}

export function buildCreatedDocument(documents, payload) {
  return {
    id: documents.length + 1,
    name: payload.name,
    type: 'documento',
    size: 'Generato',
    uploadDate: new Date().toISOString().split('T')[0],
    uploadedBy: payload.uploadedBy,
    client: payload.client,
    category: payload.category,
    status: 'approvato',
    ...buildDocumentFileMeta({
      fileName: payload.fileName || payload.name,
      mimeType: payload.mimeType || inferMimeType(payload.fileName || payload.name, payload.type),
    }),
  };
}
